module.exports = __webpack_public_path__ + "img/banner1new.0de11d5d.jpg";